export default "/images/1ceed71f7be4a388b59c7ba0f828bfa4.png";